import React from "react";
import styled from "styled-components";
import { colors } from "core/stylesheet";
import { Title, SubTitle } from "components/generic/form/service";
import linkedin from "./assets/linkedin.svg";
import youtube from "./assets/youtube.svg";
import quora from "./assets/quora.svg";
import logo from "./assets/logo.svg";

const Wrap = styled.div`
  background-color: black;
  font-family: CircularStd-Book;
  bottom: 0;
  min-height: 398px;
  width: 100%;
  @media (max-width: 680px) {
    display: none;
  }
`;
const ButtomWrap = styled.div`
  font-family: CircularStd-Book;
  @media (max-width: 680px) {
    display: none;
  }
`;

const Button = styled.a`
  color: ${colors.brand};
  @media (max-width: 680px) {
    margin-bottom: 2rem;
  }
`;

export default () => (
  <React.Fragment>
    <Wrap className="white pa4 f6">
      <div className="flex flex-row-ns flex-column">
        <div className="w-70-ns w-100 pa5-ns  tl-ns tc">
          <SubTitle>Stay in the know</SubTitle>
          <Title size={"28px"}>Our insiders tips directly to your inbox </Title>
          <div className="flex pv3 dib">
            <input
              type="email"
              name="email"
              placeholder="name@email.com"
              className="f3 input-reset bt-0 bl-0 br-0 bb b--silver b--dotted pb3 mb2 fl w-80 silver bg-transparent"
            />
            <input
              className="f3 dib button-reset bt-0 bl-0 br-0 bb b--silver b--dotted pb3 mb2 white tc bg-transparent pointer fl w-20"
              value="→"
            />
          </div>
        </div>
        <div className="fl w-30 pa2">
          <ul className="list pa4 ma0">
            <li className="pv3 bb b--silver b--dotted bt-0 br-0 bl-0">
              <a href="https://thelobby.io/careers" className="link white f4">
                About Us
              </a>
            </li>
            <li className="pv3 bb b--silver b--dotted br-0 bt-0 bl-0">
              <a href="https://thelobby.io/faq" className="link white f4">
                Frequently Asked Questions
              </a>
            </li>
            <li className="pv3 bb b--silver b--dotted br-0 bt-0 bl-0">
              <a href="https://thelobby.io/careers" className="link white f4">
                Careers - We're Hiring!
              </a>
            </li>
          </ul>
        </div>
      </div>
    </Wrap>
    <div>
      <ButtomWrap className="flex items-center w-100 bg-white silver f7  pv4 ph3">
        <div className="pl6 w-50">
          <img src={logo} alt="The Lobby Symbol" className="h2 v-mid" />
          <span className=" pl2 ">© 2018 The Lobby Inc.</span>
        </div>
        <div className="w-50">
          <span className="ph2 f7">
            <a href="https://thelobby.io/legal/privacy" className="link silver">
              Privacy
            </a>
          </span>
          <span className="ph2 f7">
            <a href="https://thelobby.io/legal/terms" className="link silver">
              Terms of Use
            </a>
          </span>
        </div>
        <div className="w-50  pa2">
          <ul className="list pa0 ma0">
            <li className="dib ph3">
              <a href="https://www.quora.com/profile/Deepak-Chhugani">
                <img src={quora} alt="Quora" className="h2" />
              </a>
            </li>
            <li className="dib ph3">
              <a href="https://www.youtube.com/channel/UCDXs4CIJVdOrGIwNbPqMd-A">
                <img src={youtube} alt="Youtube" className="h2" />
              </a>
            </li>
            <li className="dib ph3">
              <a href="https://www.linkedin.com/company-beta/11187112/">
                <img src={linkedin} alt="Linkedin" className="h2" />
              </a>
            </li>
          </ul>
        </div>
      </ButtomWrap>
    </div>
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/components/generic/layout/Overlay/Footer.js